import * as Vue from "vue-tsx-support";
import "vue-tsx-support/enable-check"
import iView from 'lb-iview'
import {VNode} from 'vue'

let IView: any = iView

export interface PageProps {
	/**
	 * 当前页码，支持 .sync 修饰符
	 * @default 1
	 */
	current?: number;
	/**
	 * 数据总数
	 * @default 0
	 */
	total?: number;
	/**
	 * 每页条数
	 * @default 10
	 */
	'pageSize'?: number;
	/**
	 * 每页条数切换的配置
	 * @default [10, 20, 30, 40]
	 */
	'pageSizeOpts'?: number[];
	/**
	 * 条数切换弹窗的展开方向，可选值为 bottom 和 top
	 * @default bottom
	 */
	placement?: string;
	/**
	 * 可选值为small（迷你版）或不填（默认）
	 */
	size?: string;
	/**
	 * 简洁版
	 * @default false
	 */
	simple?: boolean;
	/**
	 * 显示总数
	 * @default false
	 */
	'showTotal'?: boolean;
	/**
	 * 显示电梯，可以快速切换到某一页
	 * @default false
	 */
	'showElevator'?: boolean;
	/**
	 * 显示分页，用来改变page-size
	 * @default false
	 */
	'showSizer'?: boolean;
	/**
	 * 自定义 class 名称
	 */
	'className'?: string;
	/**
	 * 自定义 style 样式
	 */
	styles?: object;
	/**
	 * 是否将弹层放置于 body 内，
	 * 在 Tabs、带有 fixed 的 Table 列内使用时，建议添加此属性，
	 * 它将不受父级样式影响，从而达到更好的效果
	 * @default false
	 */
	transfer?: boolean;
	/**
	 * 替代图标显示的上一页文字
	 */
	'prevText'?: string;
	/**
	 * 替代图标显示的下一页文字
	 */
	'nextText'?: string;

	/**
	 * slot插槽对象
	 */
	$slots?: {
		/**
		 * 自定义显示总数的内容
		 */
		'': VNode[];
	};
}

export interface PageEvents {
	onOnChange: (pageNum: number) => void
	onOnPageSizeChange: (pageSize: number) => void
}

const Page = Vue.ofType<PageProps,PageEvents>().convert(IView.Page);
export default Page

